import React from "react";
import { useDispatch } from "react-redux";
import { setPreference } from "pages/preferences/preferencesActions";
import { BULLETIN } from "redux/slices/api/initialisePreferences";
import { useGetFirstPreference } from "pages/preferences/api/useGetPreferences";
import { TextAlert } from "./TextAlert";

export function ServiceNotification() {
  const dispatch = useDispatch();
  const dismiss = () => dispatch(setPreference({ key: BULLETIN, value: "" }, true));
  const resp = useGetFirstPreference(BULLETIN);
  const msg = resp ? decodeURI(resp).trim() : null;

  return msg ? <TextAlert title={msg} onDismiss={dismiss} /> : null;
}
